import { useTranslation } from "@i18n";
function EmbeddedViewer({ embedUrl, id = "" }: { embedUrl: string; id?: string }) {
  const { t } = useTranslation();
  return (
    <div className="w-full h-full" style={{ overscrollBehavior: "contain" }}>
      <iframe id={id} title={t("Embedded Link")} className="w-full h-full" src={embedUrl} />
    </div>
  );
}

export default EmbeddedViewer;
